// extracted by mini-css-extract-plugin
module.exports = {"avatarImg":"form_avatarImg_67pS8","clearButtonContainer":"form_clearButtonContainer_1PLyT"};